import styled from "styled-components";
import {Table} from "antd";

// Son denenen faturalar kutusunun tüm renkleri burada toplanır.
// Renk revizesi gerektiğinde yalnızca bu obje düzenlenmelidir; aşağıdaki styled-components
// renkleri doğrudan buradan okur.
export const lastTriedInvoicesTheme = {
    // Ödemeler tablosunda "+" ile satır açıldığında kutunun arkasında kalan dış alan
    expandedRowBackground: "#f5f6f8",

    outerBorder: "#c7d2f0", // Kutunun dış çerçevesi
    outerShadow: "rgba(92, 115, 196, 0.18)", // Kutunun dış katmanındaki gölge
    outerBackground: "#eef2fc", // Kutu gövdesi: iç tablonun etrafındaki boşluk
    headerBackground: "#e6ecfa", // Kutu başlık şeridi (ikon + başlık + "N fatura")
    headerBorder: "#d3dcf3", // Başlık şeridi ile tablo arasındaki çizgi
    headerText: "#1f1f1f", // Başlık yazısı, ikon ve aç/kapa oku
    countText: "#595959", // Sağdaki "N fatura" yazısı
    tableHeaderBackground: "#d6def5", // İç tablonun kolon başlık satırı zemini
    tableHeaderText: "#1f1f1f", // İç tablonun kolon başlık yazısı
    tableRowBackground: "#ffffff", // İç tablonun veri satırları zemini
    tableRowHoverBackground: "#f5f7fd", // İç tablo satırının üzerine gelindiğinde zemin
    tableRowBorder: "#e8e8e8" // İç tablo satırları arasındaki çizgi
};

const theme = lastTriedInvoicesTheme;

export const GroupBox = styled.div`
    border: 1px solid ${theme.outerBorder};
    background: ${theme.outerBackground};
    box-shadow: 0 2px 8px ${theme.outerShadow};
    overflow: hidden;
`;

export const GroupHeader = styled.div`
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 12px 16px;
    cursor: pointer;
    user-select: none;
    background: ${theme.headerBackground};
    border-bottom: ${props => (props.$expanded ? `1px solid ${theme.headerBorder}` : "none")};
    color: ${theme.headerText};

    .group-icon {
        font-size: 18px;
    }

    .group-title {
        flex: 1;
        font-size: 15px;
        font-weight: 500;
    }

    .group-count {
        color: ${theme.countText};
    }
`;

export const GroupContent = styled.div`
    padding: 12px;
`;

// Dıştaki TableSection'ın thead/tbody kuralları iç tabloyu da yakaladığı için "&&" ile
// özgüllük artırılır; aksi halde kolon başlıkları dış tablonun gri zeminini alır.
export const InnerTable = styled(Table)`
    && .ant-table {
        background: transparent;
    }

    && .ant-table-thead > tr > th {
        background: ${theme.tableHeaderBackground};
        color: ${theme.tableHeaderText};
        font-weight: 500;
    }

    && .ant-table-tbody > tr > td {
        background: ${theme.tableRowBackground};
        border-bottom: 1px solid ${theme.tableRowBorder};
    }

    && .ant-table-tbody > tr:hover > td {
        background: ${theme.tableRowHoverBackground};
    }
`;
